import { IKnmDistrictSelectOption } from '../interfaces/IKnmDistrictSelectOption';
import { IDistrict } from '../../../APIPackage/KnmModule/interfaces/IDistrict';

export const createDistrictSelectOption = (erknmDistrict: IDistrict): IKnmDistrictSelectOption => ({
  ...erknmDistrict,
  label: erknmDistrict.name || '',
  value: erknmDistrict.id?.toString() || '',
  code: erknmDistrict.federalRegionCode,
  id: parseInt(erknmDistrict.id?.toString() || '', 10) || 0,
});
